module.exports = __webpack_public_path__ + "img/pattern.6f0d2101.png";